import React, { useCallback, useMemo, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import './styles.scss'
import PropTypes from 'prop-types'
import MainHotel from '../../../Shared/Hotel/mainHotel'
import Button from '../../../Shared/Form/Button'
import { getHotels } from '../../../../http/driveApiGateway/client'
import { getLocation } from '../../../../http/driveApiGateway/helper'
import CompareSearch from './search'
import CompareDetail from './detail'
import Loader from '../../../Shared/Loader'

const compareView = {
  search: 0,
  compare: 1,
}
const Compare = ({ item, relatedItems, propertyImage }) => {
  const [loading, setLoading] = useState(false)
  const [, setError] = useState(false)
  const [query, setQuery] = useState('')
  const [distance, setDistance] = useState(null)
  const [compare, setCompare] = useState([])
  const [foundHotels, setFoundHotels] = useState({
    items: [],
    related: []
  })
  const [activeView, setActiveView] = useState(compareView.search)
  const { t } = useTranslation()

  const distanceOptions = useMemo(() => [
    { value: '', label: t('LABEL_AROUND_ALL') },
    { value: '10', label: `${t('LABEL_AROUND')} 10 km` },
    { value: '50', label: `${t('LABEL_AROUND')} 50 km` },
    { value: '100', label: `${t('LABEL_AROUND')} 100 km` },
    { value: '200', label: `${t('LABEL_AROUND')} 200 km` },
    { value: '500', label: `${t('LABEL_AROUND')} 500 km` },
  ], [t])

  const onQueryChange = useCallback((e) => setQuery(e.target.value), [])
  const onDistanceChange = useCallback((e) => setDistance(e.target.value), [])

  const MAX_COMPARE_HOTELS = 4
  const onAddCompare = useCallback((hotel) => {
    if (compare.length >= MAX_COMPARE_HOTELS) {
      alert('Reached maximum number of hotels to compare.')
      return
    }
    setCompare((prevCompare) => [...prevCompare, hotel])
  }, [compare])
  const onRemoveCompare = useCallback((hotel) => {
    setCompare((prevCompare) => prevCompare.filter((h) => h !== hotel))
  }, [])

  const onSearchClick = useCallback(async () => {
    try {
      setError(false)
      setLoading(true)
      const data = await getHotels(query, distance, getLocation(item)).fetchPromise
      setFoundHotels(data)
    } catch (error) {
      console.error(error)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [item, query, distance])

  const onFormSubmit = useCallback(async (e) => {
    e.preventDefault()
    await onSearchClick()
  }, [onSearchClick])

  const showCompareView = useCallback(() => {
    setActiveView(compareView.compare)
  }, [])
  const showSearchView = useCallback(() => {
    setActiveView(compareView.search)
  }, [])
  return (
    <div className="Compare">
      {
        activeView === compareView.search
        && <>
          <MainHotel
            item={item}
            relatedItems={relatedItems}
            type="main_hotel"
            propertyImage={propertyImage}
          >
            <Button onClick={showCompareView} align="right" classNames="Button-Dark"><span
              className="Button-Count">{compare.length + 1}</span> <Trans>BUTTON_VIEW_COMPARE</Trans></Button>
          </MainHotel>
          <div style={{ position: 'relative' }}>
            <CompareSearch onSearchClick={onSearchClick}
                           onFormSubmit={onFormSubmit}
                           onDistanceChange={onDistanceChange}
                           onQueryChange={onQueryChange}
                           onAddCompare={onAddCompare}
                           onRemoveCompare={onRemoveCompare}
                           distanceOptions={distanceOptions}
                           item={item}
                           distance={distance}
                           query={query}
                           foundHotels={foundHotels}
                           compare={compare}/>
            {loading && <Loader size={64}/>}
          </div>
        </>
      }
      {
        activeView === compareView.compare
        && <CompareDetail onRemoveCompare={onRemoveCompare}
                          item={item} relatedItems={relatedItems}
                          onShowSearchView={showSearchView}
                          compare={compare}/>
      }
    </div>
  )
}

Compare.propTypes = {
  giataId: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  relatedItems: PropTypes.array.isRequired,
  propertyImage: PropTypes.string,
}

export default Compare
